import { render, staticRenderFns } from "./ColumnDetail.vue?vue&type=template&id=01a2161a&scoped=true&"
import script from "./ColumnDetail.vue?vue&type=script&lang=ts&"
export * from "./ColumnDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnDetail.vue?vue&type=style&index=0&id=01a2161a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a2161a",
  null
  
)

export default component.exports